<div class="d-flex flex-column h-100" [ngClass]="expandMenu ? 'menu-expanded' : 'menu-collapsed'" (mouseleave)="startCollapseTimer()">
    <div class="layout-menu flex-grow-1">
        <div *ngFor="let entity of entities; let i = index" ngbDropdown container="body" class="item"
            placement="right-top right-bottom" display="dynamic"
            [ngClass]="{ activeEntity: currentEntity == entity.name }" #myDrop="ngbDropdown"
            (mouseenter)="this.toggleMenu(true);cancelCollapseTimer()" (mouseleave)="startCollapseTimer()">
            <a ngbDropdownToggle (mouseenter)="mouseEnter(i)" (click)="openEntity(entity, $event)">
                <i [class]="currentEntity == entity.name && entity?.fill && entity.name != 'Repo' ? entity.icon + '-fill' : entity.icon"></i>
                <span *ngIf="expandMenu">{{ entity.displayName }}</span>
            </a>
            <div *ngIf="entity?.subMenu && showSubMenu(entity) && expandMenu && currentUrlParts.length > 1"
                class="pb-2">
                <div *ngFor="let subMenu of getEntitySubmenu(entity); trackBy: trackBySubMenu">
                  <a (click)="openSubEntity(subMenu, entity, $event)" class="subItem"
                     [ngClass]="activeProperty == subMenu.name ? 'subMenuSelected' : ''"
                     [title]="subMenu.displayName">
                    @if(subMenu?.content){
                    <mat-icon>{{ subMenu.content }}</mat-icon>
                    } @else {
                      <i [class]="currentEntity == subMenu.name && subMenu?.fill ? subMenu.icon + '-fill' : subMenu.icon"></i>
                    }
                   
                    <span *ngIf="expandMenu">{{ subMenu.displayName }}</span>
                  </a>
                </div>
            </div>
            <div ngbDropdownMenu *ngIf="entity?.showMenuDropdown && getDeploymentsForEntity(entity.name)?.length > 0" (click)="openEntity(entity, $event)"
                aria-labelledby="dropdownBasic1" (mouseleave)="mouseLeave(i)" class="dropdownDepList">
                <div *ngIf="entity.name != 'Licenses'">
                    <p class="fw-bold m-0 mx-2 my-1 menuDisplayName" *ngIf="!expandMenu">{{ entity.displayName }}</p>
                    <span *ngIf="entity.name == 'Nodes' && (role == 'Global Admin' || role == 'Reader')">
                        <button ngbDropdownItem (click)="selectedQuickAccess = 'All Nodes'">
                            All Nodes
                        </button>
                    </span>
                    <span *ngFor="let access of getDeploymentsForEntity(entity.name)">
                        <button ngbDropdownItem (click)="selectedQuickAccess = access">
                            {{ access.name }}
                        </button>
                    </span>
                </div>
                <div *ngIf="entity.name == 'Licenses'">
                    <p class="fw-bold m-0 mx-2 my-1 menuDisplayName" *ngIf="!expandMenu">{{ entity.displayName }}</p>
                    <span *ngFor="let licenseName of quickAccessControls?.licenseServerNames">
                        <button ngbDropdownItem (click)="selectedQuickAccess = licenseName">
                            {{ licenseName }}
                        </button>
                    </span>
                </div>
            </div>
            <div ngbDropdownMenu
                *ngIf="entity.name == 'Licenses' && quickAccessControls?.licenseServerNames?.length > 0"
                aria-labelledby="dropdownBasic1" (mouseleave)="mouseLeave(i)" (click)="openEntity(entity, $event)">
                <div *ngIf="entity.name == 'Licenses'">
                    <p class="fw-bold m-0 mx-2 my-1 menuDisplayName" *ngIf="!expandMenu">{{ entity.displayName }}</p>
                    <span *ngFor="let licenseName of quickAccessControls?.licenseServerNames">
                        <button ngbDropdownItem (click)="selectedQuickAccess = licenseName;">
                            {{ licenseName }}
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="expandMenu" class="d-flex justify-content-center align-items-center h-40px"
        style="border-top: 1px solid var(--s-body-color);">
        <span class="text-center fw-bolder" style="color: var(--s-headerIcon-color);" title="SyncHPC Version">{{
            syncHpcVersion }}</span>
    </div>
    <div class="d-flex justify-content-center align-items-center h-50px toggleMenuToCollapse"
        style="border-top: 1px solid var(--s-body-color);" (click)="toggleMenu()">
        <i class="bi expandIcon" title="Toggle menu"
            [ngClass]="expandMenu ? 'bi-arrow-bar-left expandedTheMenu' : 'bi-arrow-bar-right'"></i>
    </div>
</div>
